import _ from 'lodash';
import { Flex } from 'components/base/layout-components';
import { Switch } from '@material-ui/core';
import Text from 'components/base/Text';
import React from 'react';

const SettingSwitch = ({
  text,
  subtext,
  checked = true,
  onChange = _.noop,
  children
}) => (
  <Flex justify='center' direction='column' mb='normal'>
    <Flex>
      <Switch size='small' checked={checked} onChange={onChange} />
      <Flex pl='normal' direction='column'>
        <Text size='large' weight={400}>
          {text}
        </Text>
        <Text size='medium' color='shuttleGray' weight={400} mt='0.5rem'>
          {subtext}
        </Text>
        {children}
      </Flex>
    </Flex>
  </Flex>
);
export default SettingSwitch;
